import React from 'react';

import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { replacePlaceholderFields } from '../placeholders';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&.MuiTypography-h6': {
      margin: theme.spacing(2),
    }
  },
  previewText: {
    lineHeight: 1.7,
    alignSelf: 'center',
  }
}));



const SMSPreview = (props) => {

  const { previewText } = props;
  const replace = previewText => replacePlaceholderFields(previewText, {}, 'sms', 'text');


  const classes = useStyles();
  const { t } = useTranslation();

  if (!previewText) return '';

  return (
    <Box>
      <div className={classes.root}>
        <Typography variant="h6">{t('messagepreview')}</Typography>
        <div className={classes.previewText}>{ replace(previewText) }</div>
      </div>
    </Box>
  );
};


export default SMSPreview;